import React from 'react'
import { DateRange, DateRangeProps } from 'react-date-range'
import classNames from 'classnames'
import Input from '../Input/Input'
import { dateService } from 'services/date.service'
import { fullDateFormat } from 'constants/dateFormats'
import 'react-date-range/dist/styles.css' // main css file
import 'react-date-range/dist/theme/default.css' // theme css file
import styles from './RangeDatePicker.module.scss'
import useComponentVisible from 'hooks/useComponentVisible'

interface RangeDatePickerProps extends DateRangeProps {
  values: Date[]
  onValuesChange: (values: Date[]) => void
  format?: string
  wrapperStyle?: string
  rangePickerStyle?: string
  inputStyle?: string
  componentVisible: {
    ref: React.MutableRefObject<any>
    setIsComponentVisible: React.Dispatch<(isVisible: any) => boolean>
    isComponentVisible: boolean
  }
}

const RangeDatePicker: React.FC<RangeDatePickerProps> = ({
  values,
  onValuesChange,
  format = fullDateFormat,
  wrapperStyle,
  rangePickerStyle,
  inputStyle,
  componentVisible,
  children,
  ...props
}) => {
  return (
    <>
      <div
        ref={componentVisible.ref}
        className={classNames(wrapperStyle, styles.wrapper)}
      >
        {!children && (
          <Input
            value={`${dateService
              .getDate(values[0])
              .format(format)} - ${dateService
              .getDate(values[1])
              .format(format)}`}
            isFormik={false}
            onChange={() => {}}
            onClick={() =>
              componentVisible.setIsComponentVisible((isVisible) => !isVisible)
            }
            className={inputStyle}
          />
        )}
        {children && (
          <div
            className={inputStyle}
            onClick={() =>
              componentVisible.setIsComponentVisible((isVisible) => !isVisible)
            }
          >
            {React.isValidElement(children) &&
              React.cloneElement(children as React.ReactElement<any>, {
                dateString: `${dateService
                  .getDate(values[0])
                  .format(format)} - ${dateService
                  .getDate(values[1])
                  .format(format)}`,
              })}
          </div>
        )}

        <div
          className={classNames(
            rangePickerStyle,
            styles.rangePicker,
            componentVisible.isComponentVisible && styles.active
          )}
        >
          <DateRange
            rangeColors={['var(--yellow)']}
            {...props}
            ranges={[
              {
                startDate: values[0],
                endDate: values[1],
                key: 'date',
              },
            ]}
            onChange={({ date }) =>
              onValuesChange([date.startDate, date.endDate])
            }
          />
        </div>
      </div>
    </>
  )
}

export default RangeDatePicker
